import { Injectable } from '@angular/core';
import { ErrorCodes } from '@shared';
import { LoggingService } from '@shared/logging';
import { RxCollection, RxDatabase, RxDocument } from 'rxdb';
import { map, Observable } from 'rxjs';
import { CentralDatabaseProvider } from '../central-database.provider';
import { LocalCredentialsModel } from '../models';
import { CentralDatabaseDbContext } from '../schemas';
import { CentralDatabaseKeys } from '../schemas/central-database-keys';

@Injectable()
export class LocalCredentialsRepository {
	private centralDb: RxDatabase<CentralDatabaseDbContext>;
	private localCredentialsCollection: RxCollection<LocalCredentialsModel>;

	public constructor(
		private centralDbProvider: CentralDatabaseProvider,
		private loggingService: LoggingService
	) {
		this.centralDb = this.centralDbProvider.getDatabase();
		this.localCredentialsCollection = this.centralDb[CentralDatabaseKeys.localCredentials];
	}

	public async insertOrUpdate(credentials: LocalCredentialsModel): Promise<void> {
		try {
			await this.localCredentialsCollection.upsert(credentials);
		} catch (error) {
			this.loggingService.error(ErrorCodes.WorkspaceDataImportInsertDatabase, error);
			throw new Error('Insert local credentials record failed');
		}
	}

	public getByUsername$(username: string): Observable<LocalCredentialsModel | null> {
		return this.localCredentialsCollection
			.findOne()
			.where(CentralDatabaseKeys.localCredentials_username)
			.eq(username)
			.$.pipe(
				map((localCredentials: RxDocument<LocalCredentialsModel | null>) =>
					localCredentials ? localCredentials.toJSON() : null
				)
			);
	}
}
